/**
 * Simple utility to join classnames
 * This is a minimal replacement since we've removed Tailwind
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
